import { PopperTooltip } from "~/common/components/Tooltip";
import type { ReactNode } from "react";
import classNames from "classnames";
import { styled, type PopperPlacementType, GlobalStyles } from "~/common/mui";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

const StyledPopperTooltip = styled(PopperTooltip)(({ theme }) => ({
  color: theme.palette.primary.main,
  "&:hover": {
    color: theme.palette.primary.onContainer,
  },
}));

// Class name for resetting tooltip padding - needs double specificity to override defaults
const RESET_TOOLTIP_CLASS = "infoCircle-resetTooltip";

/**
 * @deprecated Use InfoCircleV2 instead for new tooltip design
 */
export const InfoCircle = ({
  className,
  tooltipClassName,
  content,
  placement = "bottom",
  disableFlip,
  contentClassName,
}: {
  className?: string;
  tooltipClassName?: string;
  content: ReactNode;
  contentClassName?: string;
  placement?: PopperPlacementType;
  disableFlip?: boolean;
}) => {
  return (
    <>
      <GlobalStyles
        styles={{
          [`.${RESET_TOOLTIP_CLASS}.${RESET_TOOLTIP_CLASS}`]: {
            padding: 0,
          },
        }}
      />
      <StyledPopperTooltip
        className={className}
        tooltipContent={content}
        placement={placement}
        contentClassName={contentClassName}
        innerClassName={classNames(RESET_TOOLTIP_CLASS, tooltipClassName)}
        disableFlip={disableFlip}
      >
        <InfoOutlinedIcon  />
      </StyledPopperTooltip>
    </>
  );
};
